import { RadixNetwork } from '@radixdlt/radix-dapp-toolkit';


export let RADIX_GATEWAY_URL ='https://gateway.radix.live'; 
export let RADIX_NETWORK_ID: 1 | 2 = RadixNetwork.Mainnet;

export let DAPP_DEFINITION_ACCOUNT_ADDRESS = 'account_rdx128y905cfjwhah5nm8mpx5jnlkshmlamfdd92qnqpy6pgk428qlqxcf';
export let NFT_PACKAGE_ADDRESS = 'package_rdx1ph9yscgj730n7cdq4gzg36amjgf69ccnkfj7wcm56nqxw7enmzwr8k';
export let NFT_COMPONENT_ADDRESS = 'component_rdx1crxqkcfe02y5ph0nlj2xy5sadtdrwjnkl43egtj3rw93fuungge5rs';

export function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ');
}

export function shortenAddress(address: string | null): string {
	if (!address) {
		return '';
	}

	return address.substring(0, 7) + '...' + address.substring(address.length - 6);
}